export const setFields = (object: any, override: any) => {
  const keys = Object.keys(override);
  keys.forEach((key) => {
    object[key] = override[key];
  });
};
